export default __webpack_public_path__ + "static/media/baseball-player.92902b02.png";